import { render, staticRenderFns } from "./DataCorrectionList.vue?vue&type=template&id=4cb69244"
import script from "./DataCorrectionList.vue?vue&type=script&lang=js"
export * from "./DataCorrectionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports